import React, { useEffect } from "react";
import GameTemplate from "../../Templetes/Game/Game.template";

const GamePage = () => {
  useEffect(() => {
    document.title = "We Do Challenge - Zeko Run";
  }, []);

  return <GameTemplate />;
};

export default GamePage;
